import { render } from "./SiteIcons.vue?vue&type=template&id=6482beb4&scoped=true"
import script from "./SiteIcons.vue?vue&type=script&lang=js"
export * from "./SiteIcons.vue?vue&type=script&lang=js"

import "./SiteIcons.vue?vue&type=style&index=0&id=6482beb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6482beb4"]])

export default __exports__